// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nI-u5","content":"styles_content__3xFCU"};